import React from 'react'
import { Link, Outlet } from 'react-router-dom'
import Header from './Header'
import { toFaDigits } from '../utils/format'
import { useTrading } from '../context/TradingContext'

const Footer = () => (
  <footer className="bg-gray-900 text-gray-200 mt-16">
    <div className="container-main py-10">
      <div className="grid md:grid-cols-3 gap-8 text-sm">
        <div>
          <h4 className="font-bold text-white mb-3">طلا و نقره</h4>
          <p className="leading-6 text-gray-400">
            پلتفرم خرید و فروش آنلاین طلا و نقره؛ شمش، آب‌شده، سکه و بار با قیمت‌گذاری شفاف بر اساس قیمت خام به‌علاوهٔ درصد سود اعلام‌شده توسط مجموعه.
          </p>
        </div>
        <div>
          <h4 className="font-bold text-white mb-3">دسترسی سریع</h4>
          <ul className="space-y-2">
            <li><Link to="/products" className="text-gray-400 hover:text-white">محصولات</Link></li>
            <li><Link to="/cart" className="text-gray-400 hover:text-white">سبد خرید</Link></li>
            <li><Link to="/profile" className="text-gray-400 hover:text-white">حساب کاربری</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-bold text-white mb-3">پشتیبانی</h4>
          <p className="text-gray-400">تلفن: ۰۲۱-۲۲۳۳۴۴۵۵</p>
          <p className="text-gray-400">ایمیل: support@goldsilver.ir</p>
          <p className="text-gray-400 leading-6 mt-2 text-xs">ساعت پاسخگویی: شنبه تا پنجشنبه، ۹ تا ۱۸</p>
        </div>
      </div>
      <p className="text-xs text-gray-500 mt-8 border-t border-gray-700 pt-4 text-center">
        © همهٔ حقوق محفوظ است — {toFaDigits(new Date().getFullYear())}
      </p>
    </div>
  </footer>
)

/** نوار هشدار وضعیت معاملات (وقتی مدیر خرید یا فروش را استاپ کرده باشد) */
const StopBanner = () => {
  const { status } = useTrading()
  if (!status?.anyStopped) return null

  return (
    <div className="bg-red-600 text-white">
      <div className="container-main py-2.5 text-xs sm:text-sm flex flex-wrap items-center gap-x-4 gap-y-1 justify-center text-center">
        <b>⛔ اطلاعیه:</b>
        {status.sellStopped && <span>معاملات فروش موقتاً متوقف است و قیمت‌ها نمایش داده نمی‌شوند.</span>}
        {status.buyStopped && <span>خرید فلز از مشتریان موقتاً متوقف است.</span>}
        <span className="opacity-90">برای اطلاعات بیشتر با پشتیبانی تماس بگیرید.</span>
      </div>
    </div>
  )
}

const Layout: React.FC = () => (
  <div className="min-h-screen flex flex-col">
    <Header />
    <StopBanner />
    <main className="flex-grow">
      <Outlet />
    </main>
    <Footer />
  </div>
)

export default Layout